import React from 'react';
import { Award, Target, Users, Shield } from 'lucide-react';
import { aboutData } from '../data/mock';

const AboutSection = () => {
  const icons = [Award, Target, Users, Shield];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            {/* Section Label */}
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-navy-50 rounded-full mb-6">
              <span className="w-2 h-2 bg-navy-600 rounded-full" />
              <span className="text-navy-700 text-sm font-semibold uppercase tracking-wider">About</span>
            </div>

            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight">
              {aboutData.headline}
            </h2>

            <p className="text-lg text-slate-600 leading-relaxed mb-8">
              {aboutData.description}
            </p>

            {/* Value Propositions */}
            <div className="space-y-4">
              {[
                { icon: Shield, text: 'Trusted by hundreds of property owners and investors' },
                { icon: Target, text: 'Strategic approach tailored to your unique goals' },
                { icon: Users, text: 'Dedicated team committed to your success' }
              ].map((item, index) => (
                <div key={index} className="flex items-center gap-4">
                  <div className="w-10 h-10 bg-navy-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <item.icon className="w-5 h-5 text-navy-600" />
                  </div>
                  <span className="text-slate-700">{item.text}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right Content - Stats */}
          <div className="relative">
            {/* Background Decoration */}
            <div className="absolute inset-0 bg-gradient-to-br from-navy-50 to-silver-100 rounded-3xl transform rotate-3" />
            
            <div className="relative bg-white rounded-3xl shadow-xl p-8 md:p-12">
              <div className="grid grid-cols-2 gap-8">
                {aboutData.highlights.map((stat, index) => {
                  const Icon = icons[index];
                  return (
                    <div
                      key={index}
                      className="text-center p-6 rounded-2xl bg-gradient-to-br from-slate-50 to-silver-50 hover:shadow-lg transition-shadow duration-300"
                    >
                      <div className="w-14 h-14 bg-navy-600 rounded-xl flex items-center justify-center mx-auto mb-4">
                        <Icon className="w-7 h-7 text-white" />
                      </div>
                      <div className="text-3xl md:text-4xl font-bold text-navy-800 mb-2">
                        {stat.value}
                      </div>
                      <div className="text-sm text-slate-600 font-medium">
                        {stat.label}
                      </div>
                    </div>
                  );
                })}            </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
